var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"display-1 mt-6"},[_vm._v("Halaman tidak ditemukan")])])}
var staticRenderFns = []

export { render, staticRenderFns }